import { render, staticRenderFns } from "./Gastroranking.vue?vue&type=template&id=a851a75e&scoped=true&lang=pug"
import script from "./Gastroranking.vue?vue&type=script&lang=js"
export * from "./Gastroranking.vue?vue&type=script&lang=js"
import style0 from "./Gastroranking.vue?vue&type=style&index=0&id=a851a75e&prod&lang=scss"
import style1 from "./Gastroranking.vue?vue&type=style&index=1&id=a851a75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851a75e",
  null
  
)

export default component.exports